/**
 * @format
 * @description 表单验证封装
 */

export const regExpRule = {
	//手机号
	phone: {
		pattern: /^1[3456789]d{9}$/,
		message: '请输入正确的手机号码',
	},
	//固定电话
	telephone: {
		pattern: /^0\d{2,3}-?\d{7,8}$/,
		message: '请输入正确的固定电话号码',
	},
	//电子邮箱
	email: {
		pattern: /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/,
		message: '请输入正确的电子邮件地址',
	},
	//qq号
	qq: {
		pattern: /^[1-9][0-9]{4,10}$/,
		message: '请输入正确的qq号',
	},
	//微信号
	wechat: {
		pattern: /^[a-zA-Z][-_a-zA-Z0-9]{5,19}$/,
		message: '请输入正确的qq号',
	},
	//身份证
	idCard: {
		pattern:
			/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
		message: '请输入正确的身份证号码',
	},
	//邮政编码
	postCard: {
		pattern: /^[1-9]\d{5}$/,
		message: '请输入正确的邮政编码',
	},
	//url
	url: {
		pattern: /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/,
		message: '请输入正确的URL',
	},
	//统一社会信用代码
	socialCredit: {
		pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
		message: '请输入正确的统一社会信用代码',
	},
	//统一社会信用代码(宽松匹配)(15位/18位/20位数字/字母)
	socialCredit2: {
		pattern: /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/,
		message: '请输入正确的统一社会信用代码',
	},
	//银行卡号
	cardNo: {
		pattern: /^[1-9]\d{9,29}$/,
		message: '请输入正确的银行卡号',
	},
	//车牌号
	blend: {
		pattern:
			/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/,
		message: '请输入正确的车牌号',
	},
	//中文
	chinese: {
		pattern: /^[\u4e00-\u9fa5]*$/,
		message: '请输入中文字符',
	},
	//小写字母
	lowerCase: {
		pattern: /^[a-z]+$/,
		message: '只能包含小写字母',
	},
	//大写字母
	upperCase: {
		pattern: /^[A-Z]+$/,
		message: '只能包含大写字母',
	},
	//数字
	number: {
		pattern: /^\d+$/,
		message: '只能输入数字',
	},
	//数字+字母
	numericLetters: {
		pattern: /^[A-Za-z0-9]+$/,
		message: '只能输入数字和字母',
	},
	//小数
	decimal: {
		pattern: /^\d+\.\d+$/,
		message: '只能输入小数',
	},
	//整数
	integer: {
		pattern: /^(?:0|(?:-?[1-9]\d*))$/,
		message: '只能输入整数',
	},
	//浮点数
	float: {
		pattern: /^(-?[1-9]\d*\.\d+|-?0\.\d*[1-9]\d*|0\.0+)$/,
		message: '只能输入浮点数',
	},
	//是否为数字、字母、下划线
	numberWord_: {
		pattern: /^(-?[1-9]\d*\.\d+|-?0\.\d*[1-9]\d*|0\.0+)$/,
		message: '只能数字、字母、下划线',
	},
};

export const validateRules = {
	/**
	 * @description:input 前后出现空格验证规则
	 * @param trigger {string} 触发方式
	 */
	validateSpace: (message = '请输入', trigger = 'blur') => ({
		required: true,
		validator: (_rule, value, callback) => {
			if (!value) {
				callback(message);
			}
			if (value.trim().length === 0) {
				callback('值不能全为空格');
			} else if (value.trim() !== value) {
				callback('值前导或尾随不能包含空格');
			} else {
				callback();
			}
		},
		trigger,
	}),
	/**
	 * @description:是否必填
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	required: (message = '请输入', trigger = 'blur') => ({
		required: true,
		validator: (_rule, value, callback) => {
			if (!value) {
				callback(new Error(message));
			} else {
				callback();
			}
		},
		trigger,
	}),
	/**
	 * @description:长度区间
	 * @param minLength {number} 最小长度
	 * @param maxLength {number} 最大长度
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	range: (minLength = 0, maxLength = 0, message = '', trigger = 'blur') => ({
		min: minLength,
		max: maxLength,
		message: message || `长度应该介于${minLength}和${maxLength}之间`,
		trigger,
	}),
	/**
	 * @description:最小字符数
	 * @param minLength {number} 最小长度
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	min: (minLength = 0, message = '', trigger = 'blur') => ({
		min: minLength,
		message: message || `最少输入${minLength}个字符`,
		trigger,
	}),
	/**
	 * @description:最大字符数
	 * @param maxLength {number} 最大长度
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	max: (maxLength = 0, message = '', trigger = 'blur') => ({
		max: maxLength,
		message: message || `最多输入${maxLength}个字符`,
		trigger,
	}),
	/**
	 * @description:是否为手机号
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	phone: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.phone.message, trigger, regExpRule.phone.pattern),
	/**
	 * @description:是否为固定电话
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	telephone: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.telephone.message, trigger, regExpRule.telephone.pattern),
	/**
	 * @description:是否为电子邮箱
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	email: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.email.message, trigger, regExpRule.email.pattern),
	/**
	 * @description:是否为qq号码
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	qq: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.qq.message, trigger, regExpRule.qq.pattern),
	/**
	 * @description:是否为qq号码
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	wechat: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.wechat.message, trigger, regExpRule.wechat.pattern),
	/**
	 * @description:是否为身份证
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	idCard: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.idCard.message, trigger, regExpRule.idCard.pattern),
	/**
	 * @description:是否为邮政编码
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	postCard: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.postCard.message, trigger, regExpRule.postCard.pattern),
	/**
	 * @description:是否为url
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	url: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.url.message, trigger, regExpRule.url.pattern),
	/**
	 * @description:是否为统一社会信用代码
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	socialCredit: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.socialCredit.message, trigger, regExpRule.socialCredit.pattern),
	/**
	 * @description:是否为统一社会信用代码(宽松匹配)(15位/18位/20位数字/字母)
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	socialCredit2: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.socialCredit2.message, trigger, regExpRule.socialCredit2.pattern),
	/**
	 * @description:是否为银行卡号
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	cardNo: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.cardNo.message, trigger, regExpRule.cardNo.pattern),
	/**
	 * @description:是否为车牌号
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	blend: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.blend.message, trigger, regExpRule.blend.pattern),
	/**
	 * @description:是否为中文字符
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	chinese: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.chinese.message, trigger, regExpRule.chinese.pattern),
	/**
	 * @description:是否为小写字母
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	lowerCase: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.lowerCase.message, trigger, regExpRule.lowerCase.pattern),
	/**
	 * @description:是否为大写字母
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	upperCase: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.upperCase.message, trigger, regExpRule.upperCase.pattern),
	/**
	 * @description:是否为数字
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	number: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.number.message, trigger, regExpRule.number.pattern),
	/**
	 * @description:是否为数字+字母
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	numericLetters: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.numericLetters.message, trigger, regExpRule.numericLetters.pattern),
	/**
	 * @description:是否为小数
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	decimal: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.decimal.message, trigger, regExpRule.decimal.pattern),
	/**
	 * @description:是否为整数
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	integer: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.integer.message, trigger, regExpRule.integer.pattern),
	/**
	 * @description:是否为浮点数
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	float: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.float.message, trigger, regExpRule.float.pattern),
	/**
	 * @description:是否为数字、字母、下划线
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 */
	numberWord_: (message = '', trigger = 'blur') =>
		validateRules.extRegExp(message || regExpRule.numberWord_.message, trigger, regExpRule.numberWord_.pattern),
	/**
	 * @description:自定义校验
	 * @param message {string} 校验提示信息
	 * @param trigger {string} 触发方式
	 * @param pattern {pattern} 正则表达式
	 */
	extRegExp: (message = '', trigger = 'blur', pattern) => ({
		validator: (_rule, value, callback) => {
			if (value && value !== '') {
				if (!pattern.test(value)) {
					callback(new Error(`${message || '格式错误'}`));
				}
			}
			callback();
		},
		trigger,
	}),
};
